import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';

export default function AdminStats() {
  const [stats, setStats] = useState({
    totalProducts: 0,
    activeProducts: 0,
    inactiveProducts: 0,
    totalCategories: 0,
    recentProducts: 0,
    totalSales: 0,
    totalOrders: 0,
    monthlyRevenue: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      
      // Get all products
      const productsSnapshot = await getDocs(collection(db, 'products'));
      const products = productsSnapshot.docs.map(doc => doc.data());
      
      // Get active products
      const activeProducts = products.filter(p => p.active);
      
      // Get unique categories
      const categories = new Set(products.map(p => p.category).filter(Boolean));
      
      // Get recent products (last 7 days)
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      const recentProducts = products.filter(p => {
        const createdAt = p.createdAt?.toDate ? p.createdAt.toDate() : new Date(p.createdAt);
        return createdAt >= weekAgo;
      });

      // Get sales data (placeholder for now - you'll need to create orders collection)
      const totalSales = 0; // TODO: Implement when orders system is ready
      const totalOrders = 0; // TODO: Implement when orders system is ready
      const monthlyRevenue = 0; // TODO: Implement when orders system is ready
      
      setStats({
        totalProducts: products.length,
        activeProducts: activeProducts.length,
        inactiveProducts: products.length - activeProducts.length,
        totalCategories: categories.size,
        recentProducts: recentProducts.length,
        totalSales,
        totalOrders,
        monthlyRevenue
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading statistics...</div>;
  }

  return (
    <div className="admin-stats">
      <h2>Dashboard Overview</h2>
      
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-content">
            <h3>{stats.totalProducts}</h3>
            <p>Total Products</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{stats.activeProducts}</h3>
            <p>Active Products</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⏸️</div>
          <div className="stat-content">
            <h3>{stats.inactiveProducts}</h3>
            <p>Inactive Products</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🏷️</div>
          <div className="stat-content">
            <h3>{stats.totalCategories}</h3>
            <p>Categories</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">🆕</div>
          <div className="stat-content">
            <h3>{stats.recentProducts}</h3>
            <p>New This Week</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>${stats.totalSales.toFixed(2)}</h3>
            <p>Total Sales</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📦</div>
          <div className="stat-content">
            <h3>{stats.totalOrders}</h3>
            <p>Total Orders</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <h3>${stats.monthlyRevenue.toFixed(2)}</h3>
            <p>Monthly Revenue</p>
          </div>
        </div>
      </div>

      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <div className="action-buttons">
          <button className="action-button primary">
            ➕ Add New Product
          </button>
          <button className="action-button secondary">
            📊 View Analytics
          </button>
          <button className="action-button secondary">
            📋 Manage Orders
          </button>
        </div>
      </div>

      <div className="recent-activity">
        <h3>Recent Activity</h3>
        <div className="activity-list">
          <div className="activity-item">
            <span className="activity-icon">📦</span>
            <span className="activity-text">Product management system ready</span>
            <span className="activity-time">Just now</span>
          </div>
          <div className="activity-item">
            <span className="activity-icon">✅</span>
            <span className="activity-text">Welcome email system working</span>
            <span className="activity-time">Recently</span>
          </div>
          <div className="activity-item">
            <span className="activity-icon">🔧</span>
            <span className="activity-text">Admin dashboard updated</span>
            <span className="activity-time">Recently</span>
          </div>
        </div>
      </div>
    </div>
  );
}
